import './chatHeader.scss';

export const ChatHeaderTemplate = () => {
	/* html */
	const html = `
		<header-card></header-card>
		<header-options></header-options>
    `;

	return html;
};
